import AppStore from "@stores/AppStore";
import CompareMaterialsStore from "@stores/CompareMaterialsStore";
import ScopesStore from "@stores/ScopesStore";
import UserPermissionStore from "@stores/UserPermissionStore";
import { QueryCache, QueryClient } from "@tanstack/react-query";
import { createGlobalState } from "react-hooks-global-state";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // default: true
      retry: false,
    },
  },
});

export const queryCache = new QueryCache();

const initialState = {
  appStore: new AppStore(queryClient, queryCache),
  scopeStore: new ScopesStore(),
  upStore: new UserPermissionStore(),
  compareMaterialsStore: new CompareMaterialsStore(),
};

export const { useGlobalState } = createGlobalState(initialState);
